import { getAPIUrl } from '../helpers/App';

export const APIgetPeople = params => (
  window.axios.get(getAPIUrl('/people'), { params })
    .then(response => (response.data))
);

export const APIcreatePerson = params => (
  window.axios.post(getAPIUrl('/people'), { params })
    .then(response => (response.data))
);

export const APIupdatePerson = person => (
  window.axios.patch(getAPIUrl(`/people/${person.uuid}`), person)
    .then(response => (response.data))
);

export const APIdeletePerson = personUuid => (
  window.axios.delete(getAPIUrl(`/people/${personUuid}`))
    .then(response => (response.data))
);

export const APImergePerson = (personUuid, targetPersonUuid) => (
  window.axios.patch(getAPIUrl(`/people/${personUuid}/merge`), { target_person_uuid: targetPersonUuid })
    .then(response => (response.data))
);

export const APIupdateFace = face => (
  window.axios.patch(getAPIUrl(`/faces/${face.uuid}`), { face })
    .then(response => (response.data))
);

export const APIhideFace = faceUuid => (
  window.axios.patch(getAPIUrl(`/faces/${faceUuid}/hide`))
    .then(response => (response.data))
);

export const APIunhideFace = faceUuid => (
  window.axios.patch(getAPIUrl(`/faces/${faceUuid}/unhide`))
    .then(response => (response.data))
);
